import React, { useRef } from "react";

function ListEditor({
  items,
  setItems,
  onUpdate,
  canAdd = true,
  canDelete = true,
  validator = (value) => {
    return true;
  },
}) {
  const newItemRef = useRef();
  function onClickAdd(e) {
    if (newItemRef.current.value.trim() === "") return;
    if (validator(newItemRef.current.value.trim()) !== true) {
      alert("Please enter a valid input value.");
      return;
    }
    setItems([...items, newItemRef.current.value.trim()]);
    newItemRef.current.value = "";
  }
  function onClickDelete(e) {
    const k = e.target.getAttribute("k");
    items.splice(k, 1);
    setItems([...items]);
  }
  return (
    <div>
      <ul className="list-group">
        {items.map((source, k) => {
          return (
            <li
              className="list-group-item d-flex justify-content-between align-items-center"
              key={k}
            >
              {source}{" "}
              {canDelete && (
                <button
                  className="btn btn-sm btn-danger"
                  onClick={onClickDelete}
                  k={k}
                >
                  <i class="fa fa-trash" aria-hidden="true"></i> Delete
                </button>
              )}
            </li>
          );
        })}
      </ul>
      {canAdd && (
        <div className="input-group mt-3">
          <input ref={newItemRef} className="form-control" />
          <div className="input-group-append">
            <button className="btn btn-success" onClick={onClickAdd}>
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ListEditor;
